/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createBackOrgButtonStyles = makeStyles(() => ({
  root: {
    minHeight: '52px',
    borderRadius: '6px',
    width: '100%',
    backgroundColor: '#F6F7F8',
    padding: '8px 12px 12px 48px',
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'flex-start',
    color: '#193869',
  },
  icon: {
    position: 'absolute',
    top: '50%',
    left: '14px',
    transform: 'translateY(-50%)',
    '& .MuiSvgIcon-root': {
      width: '24px',
      height: '24px',
      color: '#193869',
      opacity: '0.7',
    },
  },
  description: {
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '-0.1px',
    lineHeight: '13px',
    opacity: '0.7',
  },
  name: {
    textAlign: 'left',
    fontSize: '18px',
    fontWeight: 'bold',
    letterSpacing: '-0.5px',
    lineHeight: '18px',
  },
}));
